import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when makeRoutePathObjects encounters a duplicate route alias. */
export class DuplicateRouteAliasError extends ClientLayerError {
  static readonly className: string = 'DuplicateRouteAliasError'

  constructor(alias: string, fullPath: string) {
    super(`Duplicate alias: ${alias} in ${fullPath}`)
    this.setMarkupOptions({ scope: 'root', section: 'routing' })
    this.addFingerprintSegment('duplicate-route-alias')
  }
}

/** Logged when makeRoutePathObjects encounters a route alias reserved for a typedRouting helper. */
export class ReservedRouteAliasError extends ClientLayerError {
  static readonly className: string = 'ReservedRouteAliasError'

  constructor(alias: string, fullPath: string) {
    super(`Reserved alias: ${alias} in ${fullPath}`)
    this.setMarkupOptions({ scope: 'root', section: 'routing' })
    this.addFingerprintSegment('reserved-route-alias')
  }
}

/** Logged when makeRoutePath receives a path starting with /. */
export class RoutePathLeadingSlashError extends ClientLayerError {
  static readonly className: string = 'RoutePathLeadingSlashError'

  constructor(path: string) {
    super(`Path '${path}' should not start with /`)
    this.setMarkupOptions({ scope: 'root', section: 'routing' })
    this.addFingerprintSegment('route-path-leading-slash')
  }
}
